import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/charger-dc-icon.svg'
import _imports_1 from '@/assets/images/charger-ac-icon.svg'
import _imports_2 from '@/assets/images/charger-has-cable-dark.svg'
import _imports_3 from '@/assets/images/charger-has-cable.svg'
import _imports_4 from '@/assets/images/charger-power.svg'


const _hoisted_1 = _imports_2
const _hoisted_2 = { class: "charger__letter" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "charger__type" }
const _hoisted_5 = { class: "charger__info" }
const _hoisted_6 = {
  key: 0,
  class: "charger__info-icon",
  src: _imports_0,
  alt: ""
}
const _hoisted_7 = {
  key: 1,
  class: "charger__info-icon",
  src: _imports_1,
  alt: ""
}
const _hoisted_8 = { class: "charger__info-text" }
const _hoisted_9 = {
  key: 0,
  class: "charger__has-cable"
}
const _hoisted_10 = { class: "charger__has-cable-text" }
const _hoisted_11 = { class: "charger__price" }
const _hoisted_12 = { class: "charger__power" }
const _hoisted_13 = { class: "charger__power-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("article", {
    class: _normalizeClass(["charger", {
      'charger--not-available': $setup.props.connector.status !== 'AVAILABLE'
    }]),
    onClick: $setup.connectorClicked
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["charger__left", $setup.classType])
    }, [
      _createElementVNode("span", _hoisted_2, _toDisplayString($props.connector.label), 1),
      _createElementVNode("img", {
        class: "charger__icon",
        src: `${$setup.config.imagesPath}/charger-${$setup.connectorTypeSlug}.svg`,
        alt: ""
      }, null, 8, _hoisted_3)
    ], 2),
    _createElementVNode("h3", _hoisted_4, _toDisplayString($setup.connectorTypeName), 1),
    _createElementVNode("div", _hoisted_5, [
      ($props.connector.mode === 'DC')
        ? (_openBlock(), _createElementBlock("img", _hoisted_6))
        : (_openBlock(), _createElementBlock("img", _hoisted_7)),
      _createElementVNode("span", _hoisted_8, _toDisplayString($props.connector.mode === "DC" ? "DC" : "AC") + " | " + _toDisplayString($props.connector.voltage) + "V | " + _toDisplayString($props.connector.current) + "A ", 1)
    ]),
    ($props.connector.connectorFormat === 'CABLE')
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _cache[0] || (_cache[0] = _createElementVNode("picture", { class: "charger__has-cable-icon" }, [
            _createElementVNode("source", {
              srcset: _hoisted_1,
              media: "(prefers-color-scheme: dark)"
            }),
            _createElementVNode("img", {
              src: _imports_3,
              alt: ""
            })
          ], -1)),
          _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("chargingPage.connectorLayout.hasCable")), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_11, _toDisplayString($setup.price), 1),
    _createElementVNode("div", _hoisted_12, [
      _cache[1] || (_cache[1] = _createElementVNode("img", {
        class: "charger__power-icon",
        src: _imports_4,
        alt: ""
      }, null, -1)),
      _createElementVNode("span", _hoisted_13, _toDisplayString($props.connector.power ? $props.connector.power / 1000 : "N/a") + " kW", 1)
    ])
  ], 2))
}